import { createAxiosApi } from 'utils/create-axios-api';

const baseURL = process.env.REACT_APP_API_URL || '';

export const customizationApi = createAxiosApi({ baseURL });
